import { render, staticRenderFns } from "./EmailTextField.vue?vue&type=template&id=6130fc24&"
import script from "./EmailTextField.vue?vue&type=script&lang=js&"
export * from "./EmailTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports